module.exports = "<div id=\"subscribe\">\n  <h3>Subscribe to our Newsletter!</h3>\n  <input #userEmail type=\"email\" (keyup)=\"onKeyup($event)\" placeholder=\"Enter your email address\" style=\"width: 260px;\">\n  <br>\n  <h4>{{errorMessage}}</h4>\n  <button id=\"submitButton\" (click)=\"submitEmail(); userEmail.value='';\" class=\"btn btn-primary\">Subscribe</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/footer/subscribe/subscribe.component.html
// module id = 416
// module chunks = 1